@if (userForm && user) {
    <form
        [formGroup]="userForm"
        class="full-width ion-margin-top">
        @if (!isNewUser && !isProfilePage() && config().tags) {
            <lib-user-tag-view
                (updateMainUserComponent)="emitReloadedUser()"
                [isButtonHidden]="!hasRightToModifyUser()"
                [isMobile]="isMobile()"
                [isNewElement]="isNewUser"
                [loggedInUser]="loggedInUser"
                [mainUserRole]="mainUserRole()"
                [user]="user"
                class="full-width" />
        }

        <curafida-card
            [title]="'USER_ACCOUNT'"
            class="full-width no-left-right-margin">
            <ion-card-content>
                @if (!isProfilePage() && hasRole() && !isNewUser) {
                    <curafida-text-input
                        [formControlName]="'patientNumber'"
                        [formGroup]="userForm"
                        [isMobile]="isMobile()"
                        [label]="'USER.PATIENT.PATIENT_NUMBER' | translate" />
                }
                @if (!isProfilePage() && config().pseudonym && hasRole() && !isNewUser) {
                    <curafida-radio-button-input
                        (ionChange)="changePseudonymActivation($event.detail.value)"
                        [defaultValue]="userForm.controls.usePseudonym.value"
                        [formControlName]="'usePseudonym'"
                        [formGroup]="userForm"
                        [isMobile]="isMobile()"
                        [itemList]="usePseudonym"
                        [label]="'PSEUDONYMIZED' | translate" />
                }
                @if (!isProfilePage() && config().pseudonym && hasRole() && userForm?.controls?.usePseudonym.value) {
                    <curafida-radio-button-input
                        (ionChange)="changePseudonymDefinition($event.detail.value)"
                        [defaultValue]="userForm.controls.pseudonymDefinition.value"
                        [formControlName]="'pseudonymDefinition'"
                        [formGroup]="userForm"
                        [isMobile]="isMobile()"
                        [itemList]="pseudonymDefinition"
                        [label]="'USER.PATIENT.PSEUDONYM_DEFINITION' | translate" />
                    <curafida-text-input
                        [disabled]="userForm.controls.usePseudonym.value"
                        [formControlName]="'pseudonym'"
                        [formGroup]="userForm"
                        [isMobile]="isMobile()"
                        [required]="true"
                        [label]="'USER.PATIENT.PSEUDONYM' | translate" />
                }
                <curafida-text-input
                    [formControlName]="'firstName'"
                    [formGroup]="userForm"
                    [isMobile]="isMobile()"
                    [label]="'FIRST_NAME' | translate" />
                <curafida-text-input
                    [formControlName]="'lastName'"
                    [formGroup]="userForm"
                    [isMobile]="isMobile()"
                    [label]="'LAST_NAME' | translate" />
                <curafida-select-input
                    [formControlName]="'title'"
                    [formGroup]="userForm"
                    [isMobile]="isMobile()"
                    [itemList]="academicTitleOptions"
                    [label]="'ACADEMIC_TITLE.TITLE' | translate" />
                @if (config().username) {
                    <curafida-text-input
                        [formControlName]="'username'"
                        [formGroup]="userForm"
                        [isMobile]="isMobile()"
                        [label]="'USERNAME' | translate" />
                }
                <curafida-text-input
                    [formControlName]="'createdAt'"
                    [formGroup]="userForm"
                    [isMobile]="isMobile()"
                    [label]="'CREATED_AT' | translate" />
                @if (!isOwnDetails() && config().accountInfo) {
                    <curafida-select-input
                        (selectionChange)="onChangeAccountType($event.detail.value)"
                        [formControlName]="'accountType'"
                        [formGroup]="userForm"
                        [isMobile]="isMobile()"
                        [itemList]="accountTypesSelection"
                        [label]="'ACCOUNT_TYPE.NAME' | translate" />
                    <curafida-select-input
                        (selectionChange)="onChangeOtpRequirement($event.detail.value)"
                        [formControlName]="'hasOtpConfigured'"
                        [formGroup]="userForm"
                        [isMobile]="isMobile()"
                        [itemList]="otpConfigurationList"
                        [label]="'2FA.NAME' | translate" />
                }
                <curafida-date-input
                    [disabledFutureDays]="true"
                    [formControlName]="'birthDate'"
                    [formGroup]="userForm"
                    [isMobile]="isMobile()"
                    [label]="'BIRTH_DATE' | translate" />
                @if (!isNewUser && (hasRightToModifyUser() || isOwnDetails())) {
                    <curafida-save-cancel-button
                        (cancelEditEmit)="cancelEdit()"
                        [saveInformationFn]="saveUserInformation.bind(this)"
                        (toggleEditEmit)="toggleEdit()"
                        [element]="user"
                        [formGroup]="userForm"
                        [isEditEnabled]="isEditEnabled"
                        [isMobile]="isMobile()"
                        [isNewElement]="isNewUser" />
                }
            </ion-card-content>
        </curafida-card>
        @if (hasRightSeeAndModifiedUserPreferences() && !isNewUser && user) {
            <user-preferences [user]="user" />
        }
        @if (config().contact) {
            <user-contact
                [rootForm]="userForm"
                [user]="user"
                [isMobile]="isMobile()"
                [isNewUser]="isNewUser"
                [hasRightToModifyUser]="hasRightToModifyUser()"
                [isOwnDetails]="isOwnDetails()"
                [isEditEnabled]="isEditEnabled"
                (cancel$)="cancelEdit()"
                (save$)="saveUserInformation()"
                (edit$)="toggleEdit()"
                (updateEmailVerified$)="userFormBackup.create()" />
        }
        @if (config().address) {
            <curafida-card
                [title]="'ADDRESS'"
                class="full-width no-left-right-margin">
                <ion-card-content>
                    <curafida-text-input
                        [formControlName]="'streetAddress'"
                        [formGroup]="userForm"
                        [isMobile]="isMobile()"
                        [label]="'STREET' | translate" />
                    <curafida-text-input
                        [formControlName]="'postalCode'"
                        [formGroup]="userForm"
                        [isMobile]="isMobile()"
                        [label]="'ZIP' | translate" />
                    <curafida-text-input
                        [formControlName]="'city'"
                        [formGroup]="userForm"
                        [isMobile]="isMobile()"
                        [label]="'LOCATION' | translate" />
                    @if (!isNewUser && (hasRightToModifyUser() || isOwnDetails())) {
                        <curafida-save-cancel-button
                            (cancelEditEmit)="cancelEdit()"
                            [saveInformationFn]="saveUserInformation.bind(this)"
                            (toggleEditEmit)="toggleEdit()"
                            [element]="user"
                            [formGroup]="userForm"
                            [isEditEnabled]="isEditEnabled"
                            [isMobile]="isMobile()"
                            [isNewElement]="isNewUser" />
                    }
                </ion-card-content>
            </curafida-card>
        }

        @if (!isPatientForConsultation || !isPatientForScreening || !isPatientForOrder) {
            @for (schemaGroup of customPropertySchemas; track schemaGroup.uuid) {
                @if (schemaGroup.hasVisiblePropertySchemas(userForm)) {
                    <curafida-card
                        [title]="schemaGroup.displayName"
                        class="full-width no-left-right-margin">
                        <ion-card-content>
                            @for (schema of schemaGroup.propertySchemas; track schema.uuid) {
                                @if (
                                    (!schema.displayOptions ||
                                        schema.displayOptions?.options?.displayType === 'STRING') &&
                                    schema.isVisible(userForm)
                                ) {
                                    <curafida-text-input
                                        [formControlName]="schema.name"
                                        [formGroup]="userForm"
                                        [isMobile]="isMobile()"
                                        [label]="schema.displayName" />
                                }
                                @if (
                                    (!schema.displayOptions ||
                                        schema.displayOptions?.options?.displayType === 'STRING') &&
                                    schema.isVisible(userForm) &&
                                    schema.validationRequired === true
                                ) {
                                    <curafida-text-input
                                        [formControlName]="schema.getRepeatValidationInputFormControlName()"
                                        [formGroup]="userForm"
                                        [isMobile]="isMobile()"
                                        [label]="schema.displayName + ' (Validierung)'"
                                        (paste)="(false)" />
                                } @else if (
                                    (!schema.displayOptions ||
                                        schema.displayOptions?.options?.displayType === 'STRING') &&
                                    schema.isVisible(userForm) &&
                                    schema.validationEnabled === true
                                ) {
                                    <curafida-checkbox-input
                                        [formControlName]="schema.getRepeatValidationCheckBoxFormControlName()"
                                        (ionChange)="onRepeatValidationCheckboxChanged($event, schema)"
                                        [formGroup]="userForm"
                                        [isMobile]="isMobile()"
                                        [label]="'Validierung aktivieren'" />
                                    <curafida-text-input
                                        [formControlName]="schema.getRepeatValidationInputFormControlName()"
                                        [formGroup]="userForm"
                                        [isMobile]="isMobile()"
                                        [label]="schema.displayName + ' (Validierung)'"
                                        (paste)="(false)"
                                        [hidden]="
                                            !userForm.get(schema.getRepeatValidationCheckBoxFormControlName()).value
                                        " />
                                }
                                @if (
                                    schema.displayOptions?.options?.displayType === 'DATE' && schema.isVisible(userForm)
                                ) {
                                    <curafida-date-input
                                        [formControlName]="schema.name"
                                        [formGroup]="userForm"
                                        [isMobile]="isMobile()"
                                        [label]="schema.displayName" />
                                }
                                @if (
                                    schema.displayOptions?.options?.displayType === 'SELECT' &&
                                    schema.isVisible(userForm)
                                ) {
                                    <curafida-select-input
                                        [formControlName]="schema.name"
                                        [formGroup]="userForm"
                                        [isMobile]="isMobile()"
                                        [itemList]="schema.answerOptions"
                                        [label]="schema.displayName" />
                                }
                                @if (
                                    schema.displayOptions?.options?.displayType === 'FILES' &&
                                    schema.isVisible(userForm)
                                ) {
                                    <curafida-content-input
                                        (addMultipleContents)="userForm.updateValueAndValidity()"
                                        (openOneContent)="openCustomPropertyFile($event)"
                                        (removeOneContent)="stageCustomPropertyFileDeletion($event)"
                                        (removeStagedContent)="userForm.updateValueAndValidity()"
                                        [addButtonLabel]="'QUESTIONNAIRE.FILE.PICK'"
                                        [contents]="contentsOfCustomProperty(schema)"
                                        [contentsAsLinks]="true"
                                        [fileUploadForm]="fileFormOfCustomProperty(schema)"
                                        [formGroup]="userForm"
                                        [isEditEnabled]="isEditEnabled && mayEditCustomProperty(schema)"
                                        [isMobile]="isMobile()"
                                        [isRequired]="schema.required"
                                        [title]="schema.displayName" />
                                }
                            }
                            @if (!isNewUser && (hasRightToModifyUser() || isOwnDetails())) {
                                <curafida-save-cancel-button
                                    (cancelEditEmit)="cancelEdit()"
                                    [saveInformationFn]="saveUserInformation.bind(this)"
                                    (toggleEditEmit)="toggleEdit()"
                                    [element]="user"
                                    [formGroup]="userForm"
                                    [isEditEnabled]="isEditEnabled"
                                    [isMobile]="isMobile()"
                                    [isNewElement]="isNewUser" />
                            }
                        </ion-card-content>
                    </curafida-card>
                }
            }
        }

        @if (isPatientCareManagementActive() && patientDossier$ | async; as patientDossier) {
            <curafida-patient-care-management
                (updateMainUserComponent)="emitReloadedUser()"
                [isButtonHidden]="patientDossier | noAuthorization: 'caregivers' : 'write'"
                [isMobile]="isMobile()"
                [managedUserRole]="UserRoles.CAREGIVER"
                [patientDossier]="patientDossier"
                [patient]="user" />
            <curafida-patient-care-management
                (updateMainUserComponent)="emitReloadedUser()"
                [isButtonHidden]="patientDossier | noAuthorization: 'supervisors' : 'write'"
                [isMobile]="isMobile()"
                [managedUserRole]="UserRoles.SUPERVISOR"
                [patientDossier]="patientDossier"
                [patient]="user" />
        }

        @if (
            configService.frontendConfig().features.organisation?.enabled &&
            !isPatientForConsultation &&
            !isPatientForOrder &&
            (isPatientForScreening || hasRole(UserRoles.CAREGIVER))
        ) {
            <curafida-card
                (setActionButton)="changeGroup()"
                [actionButtons]="groupActionButtons"
                [areButtonsVisible]="!isEditEnabled && !isProfilePage()"
                [disabled]="onlyOneGroupAvailable || !hasRightToModifyUser() || isOwnDetails() || !isGroupManager"
                [title]="'ORGANISATION_MANAGEMENT.GROUP.PLURAL'"
                class="full-width no-left-right-margin">
                <ion-card-content>
                    @if (groupListConfig.emptyListLabel) {
                        <curafida-table
                            [isLoading]="{ success: true, processing: false }"
                            [listTableConfig]="groupListConfig" />
                    }
                </ion-card-content>
            </curafida-card>
        }
        @if (
            (loggedInUser.roles.includes(UserRoles.manage_user) ||
                loggedInUser.roles.includes(UserRoles.create_patient) ||
                loggedInUser.roles.includes(UserRoles.create_supervised_patient)) &&
            user &&
            !user.roles.includes(UserRoles.PATIENT)
        ) {
            <user-role-card
                #UserRoleCardComponent
                [featureConfigs]="configService.frontendConfig().features"
                [hasRightToModifyUser]="hasRightToModifyUser()"
                [isEditEnabled]="isEditEnabled"
                [isMobile]="isMobile()"
                [isNewUser]="isNewUser"
                [isOwnDetails]="isOwnDetails()"
                [loggedInUser]="loggedInUser"
                [url]="getLocation()"
                [user]="user" />
        }
        @if (isNewUser) {
            <curafida-save-cancel-button
                (cancelEditEmit)="cancelEdit()"
                [saveInformationFn]="saveUserInformation.bind(this)"
                (toggleEditEmit)="toggleEdit()"
                [element]="user"
                [formGroup]="userForm"
                [isEditEnabled]="isEditEnabled"
                [isMobile]="isMobile()"
                [isNewElement]="isNewUser" />
        }
    </form>
}
